<template>
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
  >
    <path d="M0 0.5C0 0.223858 0.223858 0 0.5 0H8.5C8.77614 0 9 0.223858 9 0.5C9 0.776142 8.77614 1 8.5 1H0.5C0.223858 1 0 0.776142 0 0.5ZM0 8.5C0 8.22386 0.223858 8 0.5 8H7.5C7.77614 8 8 8.22386 8 8.5C8 8.77614 7.77614 9 7.5 9H0.5C0.223858 9 0 8.77614 0 8.5ZM0.5 4C0.223858 4 0 4.22386 0 4.5C0 4.77614 0.223858 5 0.5 5H11.5C11.7761 5 12 4.77614 12 4.5C12 4.22386 11.7761 4 11.5 4H0.5Z" />
  </svg>
</template>
